import styled from 'styled-components';
import { gutterHalf } from '../constants';
export const Row = styled.div `
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${gutterHalf};
  width: 100%;
`;
//# sourceMappingURL=index.js.map